module.exports = __webpack_public_path__ + "img/6-1_05.53bf23aa.jpg";